import React from "react";
import { CircularProgress } from "@mui/material";
import { makeStyles } from "@/compat/muiStyles";
import { Alert } from "@mui/material";
import FormSection from "../formcompleter/FormSection";

const useStyles = makeStyles((theme) => ({
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
  },
  errorContainer: {
    marginTop: theme.spacing(2),
  },
  sectionsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
}));

function IncidentInvestigationForm({incidentForm}) {
  const classes = useStyles();

  if (incidentForm.isLoading)
    return (
      <div className={classes.loadingContainer}>
        <CircularProgress />
      </div>
    );

  if (incidentForm.isError)
    return (
      <div className={classes.errorContainer}>
        <Alert severity="error">
          {incidentForm.error?.message ?? "Could not load incident investigation form."}
        </Alert>
      </div>
    );

  return (
    <div className={classes.sectionsContainer}>
      {incidentForm.data?.templateVersion?.investigationSections.map((section) => (
        <FormSection key={section.id} section={section} flat />
      ))}
    </div>
  );
}

export default IncidentInvestigationForm;
